import { render, staticRenderFns } from "./App.vue?vue&type=template&id=8eeffc8a&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mapengsheng/Documents/LEARN/WEBPACK/marain-build-webpack2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eeffc8a')) {
      api.createRecord('8eeffc8a', component.options)
    } else {
      api.reload('8eeffc8a', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=8eeffc8a&", function () {
      api.rerender('8eeffc8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/index/App.vue"
export default component.exports